<template>
  <div class="panel-in-tab">
    <search-box class="search-box">
      <el-form :model="form" :inline="true" size="mini" ref="searchForm" label-width="85px">
        <el-form-item label="工号">
          <el-input v-model.trim="form.workNo" @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="form.userName" @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
        <el-button type="warning" size="small" @click="reset">重置</el-button>
      </template>
    </search-box>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="small" @click="add">新增</el-button>
        <el-button type="primary" size="small" @click="importExcel">导入</el-button>
      </template>
      <el-table
        :data="tableData.list"
        ref="tableRef"
        border
        highlight-current-row
        stripe
        :header-cell-style="{textAlign: 'center'}"
        :cell-style="{textAlign: 'center'}"
        :header-cell-class-name="headerStyle"
        :height="maxTableHeight"
        v-loading="loading"
      >
        <el-table-column label="摄影师" min-width="80px">
          <el-table-column label="工号" prop="workNoMain" min-width="150px" show-overflow-tooltip></el-table-column>
          <el-table-column label="姓名" prop="userNameMain" show-overflow-tooltip></el-table-column>
        </el-table-column>
        <el-table-column label="摄影助理" min-width="80px" align="center">
          <el-table-column label="工号" prop="workNoDeputy" min-width="150px" show-overflow-tooltip></el-table-column>
          <el-table-column label="姓名" prop="userNameDeputy" show-overflow-tooltip></el-table-column>
        </el-table-column>
        <el-table-column label="操作" width="120px" align="center">
          <template slot-scope="scoped">
            <el-link type="primary" :underline="false" @click="edit(scoped.row)">编辑</el-link>
            <el-link type="primary" :underline="false" style="color: red" @click="delRow(scoped.row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>

    <add-dialog
      ref="content"
      :visible.sync="isShowAdd"
      @success="onSearch"
      v-if="isShowAdd"
    ></add-dialog>
    <edit-dialog
      ref="content"
      :visible.sync="isShowEdit"
      :rowData="rowData"
      @success="onSearch"
      v-if="isShowEdit"
    ></edit-dialog>
  </div>
</template>

<script>
import axios from "@/utils/axiosInstance";
import addDialog from "./components/add";
import editDialog from "./components/edit";
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'

export default {
  mixins: [tableMixin, pagePathMixin],
  components: { addDialog, editDialog },
  data() {
    return {
      form: {
        storeName: "",
        workJobs: "",
        customerServiceLevel: "",
      },
      tableHeight: 0,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      isShowAdd: false,
      isShowEdit: false,
      dialogConfig: {},
      rowData: {},
      storeList: [],
      queryCriteria: [],
      searchFormData: [],
      loading: false,
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  computed: {},
  mounted() {
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.$refs.tableRef.clearSelection();
      this.tableData.pageNum = 1;
      this.init();
    },
    async init(type) {
      this.loading = true;
      let data = { ...this.currencyForm };
      data.pageSize = this.tableData.pageSize;
      data.pageNum = this.tableData.pageNum;
      data.reportCode = "newProductCameramanConfig";
      data.queryMatch = [];
      data.hasCount = "Y";
      data.param = this.form
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/newProductCameramanConfig`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },
    // 重置
    reset() {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = 30;
      this.form = {
        storeName: "",
        workJobs: "",
        customerServiceLevel: "",
      };
      this.onSearch();
    },
    async delRow(row) {
      let status = await this.$confirm("是否确认删除该条数据？", "提示", { type: "warning" });
      if (status !== "confirm") return;
      let res = await this.$q.newProduct.cameramanConfigDel({ fragment: [row.dataId] });
      if (res.success) {
        this.$message.success("删除成功");
      } else {
        this.$message.fail("删除失败");
      }
      this.init();
    },
    // 新增 弹出dialog
    add() {
      this.rowData = null;
      this.isShowAdd = true;
    },
    // 修改 弹出dialog
    edit(row) {
      this.rowData = {...row};
      this.isShowEdit = true;
    },
    //导入
    importExcel() {
      this.openSubPage({
        path: "/photographerConfigurationImport",
        query: {
          fileName: "摄影师配置导入.xlsx",
          appCode: "ec-pc-new",
          reportName: "newProductCameramanConfigImport",
        },
      });
    },
    headerStyle({row, column, rowIndex, columnIndex}) {
      if(column.label != '摄影师' && column.label != '摄影助理' && column.label !='操作') {
        return 'color'
      }
    }
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0

>>> .color {
  background: #FFF1EC !important
}
</style>
<style lang="css">
.el-tooltip__popper {
  max-width: 40%;
}
</style>
